import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action, Store} from '@ngrx/store';
import {filter, map} from 'rxjs/operators';
import * as actionsUi from './qschecks-controlling-filter.actions.ui';
import {PageState} from './qschecks-controlling-filter.reducer';
import {GetFunktionsbereichePruefplaeneControllingAction, GetPruefplanFilterAction} from '../../../../client-ngrx/qschecks';


@Injectable()
export class QschecksControllingFilterPageUiEffects {

    pageReset$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA, actionsUi.FUNKTIONSBEREICH_PRUEFPLAENE_LADEN)
        , map(() => {
            return new GetFunktionsbereichePruefplaeneControllingAction();
        })
    ));

    pruefplanSelected$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<actionsUi.AktuellenPruefplanSetzenAction>(actionsUi.AKTUELLEN_PRUEFPLAN_SETZEN)
        , filter((x) => x.payload !== null)
        , map((x) => {
            return new GetPruefplanFilterAction(x.payload.pruefplan_id);
        })
    ));

    pruefplanIdSelected$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<actionsUi.AktuellePruefplanIdSetzenAction>(actionsUi.AKTUELLE_PRUEFPLAN_ID_SETZEN)
        , filter((x) => x.payload !== null)
        , map((x) => {
            return new GetPruefplanFilterAction(x.payload);
        })
    ));

    constructor(private actions$: Actions,
                private store: Store<PageState>) {
    }
}
